import React, { useState, useEffect } from 'react';
import { useLocation } from "wouter";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import { absURL } from '../utils';
import QuizAPI from '../QuizApi';

export default function QuizAliasAuth({ quizId }) {

  const [location, setLocation] = useLocation();
  const [isInstanceNotFound, setIsInstanceNotFound] = useState(false);

  const [isAdminLiveLink, setIsAdminLiveLink] = useState(
    () => new URLSearchParams(window.location.search).has("adm"));

  useEffect(() => {

    const fn = async () => {

      const responseBody = await QuizAPI.quizLiveInstanceCreate(quizId)

      if (responseBody && responseBody.success 
        && responseBody.response 
        && responseBody.response.quizInstanceId
        && responseBody.response.defaultAccessId)
      {
        if (isAdminLiveLink) {
          setLocation(absURL(`/${responseBody.response.defaultAccessId}/admin`));
        }
        else {
          setLocation(absURL(`/${responseBody.response.defaultAccessId}`));
        }
      }
      else 
      {
        setIsInstanceNotFound(true);
      }
    }

    fn();

  }, [ quizId, isAdminLiveLink ]);


  return (
    <div id="quizLive" className="bg-purple h-100">
      <Container fluid className="d-flex align-items-center justify-content-center h-100">
        <Row> 
          <Col>
            {isInstanceNotFound && <>

              <h2 className="text-center">
                <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2"/>
              </h2>
              <h3>Det uppstod ett fel</h3>
              <div>Vi kunde inte hämta quizzen ...</div>
            </>}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
